import type { ComprobacionFace, ResultadoComprobacionFace } from '@shared/certificados';
import { formatearFecha } from '@/utils/avisoCertificado';

const ENTORNOS = { pruebas: 'pruebas', produccion: 'producción' } as const;

/** Frase para la tarjeta del certificado: cuál fue la última comprobación contra FACe. */
export function describirComprobacion(comprobacion: ComprobacionFace): string {
  // `entorno` es null si no se llegó a consultar: entonces no se dice «en …».
  // Un entorno que aún no conocemos tampoco se nombra.
  const nombreEntorno = comprobacion.entorno ? ENTORNOS[comprobacion.entorno] : undefined;
  const en = nombreEntorno ? ` en ${nombreEntorno}` : '';
  const fecha = formatearFecha(comprobacion.fecha);
  // El compilador avisa si se añade un resultado nuevo al modelo compartido.
  const resultados: Record<ResultadoComprobacionFace, string> = {
    aceptado: `aceptado${en}`,
    rechazado: `rechazado por FACe${en}`,
    error: `FACe no respondió${en}`,
    no_verificable: `no verificable${en}`,
    omitida: 'no aplicable (FACe no configurado)',
    forzada: 'activado sin comprobar',
  };
  // Un servidor más nuevo que el cliente puede devolver un resultado que aún no conocemos.
  const conocidos: Partial<Record<string, string>> = resultados;
  const resultado = conocidos[comprobacion.resultado] ?? `resultado desconocido${en}`;
  return `Última comprobación de FACe: ${resultado}${fecha ? ` el ${fecha}` : ''}`;
}
